
export default {
  name: 'TableList',
  inheritAttrs: false,
  provide() {
    return {
      tableList: this
    }
  },
  props: {
    items: {
      type: Array,
      default: null
    },
    compact: {
      type: Boolean,
      default: false
    },
    expand: {
      type: Boolean,
      default: false
    },
    gap: {
      type: [String, Object],
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  vessel: {
    table: {
      borderWidth: 1,
      borderRadius: 'lg',
      paddingX: 'sm',
      paddingY: 'xs',
      lg: {
        paddingX: 'lg',
        paddingY: 'sm',
      }
    }
  },
  computed: {
    isCompact() {
      return this.$screen.lg && this.compact || this.expand
    },
    tableClass() {
      return this.isCompact && !this.expand ? this.$vessels.table : null
    },
    itemGap() {
      if (this.gap) {
        return this.gap
      } else {
        return !this.isCompact && 'md'
      }
    }
  }
}
